import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RateLimitOverride} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class RateLimitOverrideService {
    url = '/api/v1/admin/rate-limit-overrides';

    constructor(public http: HttpClient) {
    }

    getOverrides(): Observable<RateLimitOverride[]> {
        return this.http.get<RateLimitOverride[]>(this.url);
    }

    addOverride(override: RateLimitOverride): Observable<RateLimitOverride> {
        return this.http.post<RateLimitOverride>(this.url, override);
    }

    updateOverride(id: number, override: RateLimitOverride): Observable<RateLimitOverride> {
        return this.http.put<RateLimitOverride>(`${this.url}/${id}`, override);
    }

    removeOverride(id: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${id}`);
    }
}
